import { styled } from '@mui/material'
import AvatarWrapper from '../wrapper/AvatarWrapper'

export const CustomAvatar = styled(AvatarWrapper)(() => ({
  backgroundColor: '#f44336',
  border: '1px solid #ffffff',
  width: 160,
  height: 160
}))
